<template>
  <div>
    <div v-if="!this.pageLoading">
      <router-view/>
    </div>
    <van-loading vertical v-else>加载中...</van-loading>
  </div>
</template>
<script>


import apiAxios from "@/api/axios";

export default {
  data() {
    return {
      pageLoading: true
    }
  },
  async created() {
    //初始化用户信息
    const userInfo = await this.$store.dispatch('common/getUserInfo', this.$jobfairId)

    //初始化招聘会信息
    await this.$store.dispatch('common/getJobfairInfo', this.$jobfairId);

    //初始化用户im信息
    if (userInfo.data.is_login) {
      //已登录用户
      const imUserInfo = await this.$store.dispatch('common/getImUserInfo', {
        userId: userInfo.data.id, jobfairId: this.$jobfairId
      })
      //im登录
      this.imUserLogin(imUserInfo.data)
    } else {
      //未登录用户不用等tim初始化
      this.pageLoading = false
    }
    //im登录后异步事件注册
    this.registerImCallback()
  },
  mounted() {
    //初始化ws,维护在线状态
    this.$njws.onmessage = (e) => {
      const data = eval("(" + e.data + ")");
      const type = data.type || '';
      switch (type) {
          // Events.php中返回的init类型的消息，将client_id发给后台进行uid绑定
        case 'init':
          apiAxios({
            url: 'im/common/bind',
            method: 'post',
            data: {
              client_id: data.client_id,
              jobfair_id: this.$jobfairId,
            }
          })
          break;
        case '@heart@':
          //收到心跳后,拉去最新在线用户/10秒
          this.$njws.send(JSON.stringify({
            mode: 'get_online_user',
            jobfair_id: this.$jobfairId,
          }));
          break;
        case 'fresh_list':
          //更新页面数据
          if (data.detail) {
            this.$store.commit('common/update_jobfair_info', data.detail)
          }
          //刷新在线情况
          if (data.person) {
            this.$store.commit('common/update_person_live', data.person)
          }
          if (data.company) {
            this.$store.commit('common/update_company_live', data.company)
          }
          break;
        default:
          break;
      }
    }
  },
  //vue实例销毁前
  beforeDestroy() {
    //销毁im
    this.tim.destroy();
    //销毁websocket
    this.$njws.close();
  },
  methods: {
    //im登录
    imUserLogin(imUserInfo) {
      this.tim.login({
        userID: imUserInfo.im_user_id,
        userSig: imUserInfo.im_user_sign,
      }).then(() => {
        this.$store.commit('user/toggleIsLogin', true)
        this.$store.commit('startComputeCurrent')
        this.$store.commit({
          type: 'user/GET_USER_INFO',
          userID: imUserInfo.im_user_id,
          userSig: imUserInfo.im_user_sign,
          sdkAppID: process.env.VUE_APP_APPID,
        })
        this.$toast.clear()
      }).catch((error) => {
        this.$toast.fail('[ChatView]登录失败：' + error.message)
      })
    },
    //im登录后异步事件注册
    registerImCallback() {
      this.tim.on(this.TIM.EVENT.SDK_READY, this.onReadyStateUpdate, this)
      this.tim.on(this.TIM.EVENT.SDK_NOT_READY, this.onReadyStateUpdate, this)
      // 会话列表更新
      this.tim.on(this.TIM.EVENT.CONVERSATION_LIST_UPDATED, this.onUpdateConversationList)
      // 网络监测
      this.tim.on(this.TIM.EVENT.NET_STATE_CHANGE, this.onNetStateChange)
      // 收到新消息
      this.tim.on(this.TIM.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage)
      // 已读回执
      this.tim.on(this.TIM.EVENT.MESSAGE_READ_BY_PEER, this.onMessageReadByPeer)
      // 好友
      this.tim.on(this.TIM.EVENT.FRIEND_LIST_UPDATED, this.onFriendListUpdated)
      // 好友申请
      this.tim.on(this.TIM.EVENT.FRIEND_APPLICATION_LIST_UPDATED, this.onFriendApplicationListUpdated)
    },
    //imsdk初始化完成
    onReadyStateUpdate({name}) {
      const isSDKReady = name === this.TIM.EVENT.SDK_READY
      this.$store.commit('user/toggleIsSDKReady', isSDKReady)
      if (isSDKReady) {
        //获取im会话列表
        this.tim.getConversationList()
        //获取im个人资料
        this.tim.getMyProfile()
            .then(({data}) => {
              this.$store.commit('user/updateCurrentUserProfile', data)
              //已登录用户tim初始化完成后页面加载完成
              this.pageLoading = false
            })
            .catch((error) => {
              this.$toast.fail(error.message)
            })
      }

    },
    //会话列表更新回调
    onUpdateConversationList: function (event) {
      this.$store.commit('conversation/updateConversationList', event.data)
    },
    //网络状态更改回调
    onNetStateChange(event) {
      switch (event.data.state) {
        case this.TIM.TYPES.NET_STATE_CONNECTED:
          return this.$toast.success('已接入网络')
        case this.TIM.TYPES.NET_STATE_CONNECTING:
          return this.$toast.fail('当前网络不稳定')
        case this.TIM.TYPES.NET_STATE_DISCONNECTED:
          return this.$toast.fail('当前网络不可用')
        default:
          return ''
      }
    },
    //收到新消息回调
    onReceiveMessage({data: messageList}) {
      this.$store.commit('conversation/pushCurrentMessageList', messageList)
      this.$bus.$emit('scroll-bottom')
    },
    //已读消息回调
    onMessageReadByPeer() {
      // console.log('read')
      // event.data - 存储 Message 对象的数组 - [Message] - 每个 Message 对象的 isPeerRead 属性值为 true
    },
    //好友列表更新回调
    onFriendListUpdated(data) {
      this.$store.commit('friend/updateFriendList', data.data)
    },
    //好友申请更新回调
    onFriendApplicationListUpdated(data) {
      this.$store.commit('friend/updateApplicationList', data.data.friendApplicationList)
      this.$store.commit('friend/updateUnreadCount', data.data.unreadCount)
    },
  }
}
</script>
<style lang="stylus" scoped>

</style>
